/**
 * Recipient groups - a named, reusable list of people to invite.
 *
 * WHAT A GROUP IS: a shortcut for filling the attendee list on a meeting
 * or engagement. Selecting one EXPANDS into ordinary attendees; the event
 * does not store the group, and editing a group never changes a meeting
 * that has already been created.
 *
 * ADDITIVE, AND ONE-WAY. Choosing a group ADDS its members to whoever is
 * already selected, and individuals can still be added or removed on the
 * meeting afterwards. Nothing done on a meeting is ever written back to
 * the group - a person added to one meeting does not join the group. The
 * group is edited only in Settings.
 *
 * MEMBERS ARE INTERNAL USERS ONLY. Stakeholders cannot RSVP, cannot be
 * notified and have no calendar to clash with, which is why they live in
 * `calendar_event_guests` rather than among attendees.
 */
/** Belt and braces for the UI; the API enforces the same numbers. */
export const RECIPIENT_GROUP_NAME_MAX = 100;
export const RECIPIENT_GROUP_DESCRIPTION_MAX = 300;
export const RECIPIENT_GROUP_MEMBERS_MAX = 200;
//# sourceMappingURL=recipient-groups.js.map